import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BooklistEntryPage } from '@/features/productRequisition/pages/BooklistEntryPage';
import { booklistSheetSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/booklisted-institution/$projectId')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.BOOKLISTED_INSTITUTE_VIEW),
  validateSearch: booklistSheetSearchSchema,
  params: {
    parse: ({ projectId }) => ({ projectId: Number(projectId) }),
    stringify: ({ projectId }) => ({ projectId: String(projectId) }),
  },
  component: () => (
    <ErrorBoundary moduleName="Book List Entry">
      <Suspense fallback={<PageLoader />}>
        <BooklistEntryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
